import ContaPagarModel from "./contaPagarModel";

export default class ContaPagarMultiplasModel extends ContaPagarModel {
    juros = 0;
    desconto = 0;
    valorPago = 0;
}
